// The dashboard's `unit.rsoc.style` values. `cards` is a grid of tiles (what
// the live config sends); `list` is one row per search. Its own leaf module,
// re-exported by defaults.js, so boot() can validate a unit's style without
// pulling every other default into the lean boot bundle.
export const RSOC_STYLES = Object.freeze({ CARDS: 'cards', LIST: 'list' });
